import { render, staticRenderFns } from "./TransferirModalComponent.vue?vue&type=template&id=4e56bf9b"
import script from "./TransferirModalComponent.vue?vue&type=script&lang=js"
export * from "./TransferirModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e56bf9b')) {
      api.createRecord('4e56bf9b', component.options)
    } else {
      api.reload('4e56bf9b', component.options)
    }
    module.hot.accept("./TransferirModalComponent.vue?vue&type=template&id=4e56bf9b", function () {
      api.rerender('4e56bf9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/modals/TransferirModalComponent.vue"
export default component.exports